__turbopack_context__.v({
  "divider": "_0rmO7G_divider",
  "icon": "_0rmO7G_icon",
  "item": "_0rmO7G_item",
  "location": "_0rmO7G_location",
  "overflowTrigger": "_0rmO7G_overflowTrigger",
  "root": "_0rmO7G_root",
});
